import { defineStore } from 'pinia';

const useAside = defineStore('useAside', {
    state: () => {
        return {
            isShow: false,
        };
    },
    actions: {
        // 显示侧边栏
        showAside() {
            this.isShow = true;
        },
        // 隐藏侧边栏
        hideAside() {
            this.isShow = false;
        },
    },
});

export default useAside;
